<script>
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import toPairs from "lodash/toPairs";
export default {
  props: {
    item: Object,
    gameId: String
  },
  data() {
    let trainingTime = "--";
    let startTime = "--";
    let age = "--岁";
    let ageParams = undefined;
    if (this.item.trainingStartedAt && this.item.trainingEndedAt) {
      const start = moment(this.item.trainingStartedAt);
      const end = moment(this.item.trainingEndedAt);
      startTime = start.format("MM-DD HH:mm:ss");
      trainingTime = end.diff(start, "seconds");
    }

    if (this.item.birth) {
      const number = moment()
        .endOf("months")
        .diff(this.item.birth, "months");
      ageParams = Math.floor(number / 12);
      if (number % 12 > 0) {
        age = `${Math.floor(number / 12)}岁${number % 12}个月`;
      } else {
        age = `${Math.floor(number / 12)}岁`;
      }
    }
    return {
      isDetails: false,
      age,
      gridData: [],
      tableTitle: [],
      trainingId: this.item.trainingId || null,
      totalTime: undefined,
      trainingTime: trainingTime,
      startTime: startTime,
      ageParams,
      avgData: [],
      refreshTable: true
    };
  },
  mounted() {},
  methods: {
    async onClick() {
      let data = await this.$http.getGameDetileTable(this.item.trainingId);
      let avgData = await this.$http.getPatientGameAvgStatistic(this.gameId, {
        age: this.ageParams
      });
      this.avgData = avgData;

      if (data && data.result) {
        let titleArr = [];
        let table = JSON.parse(data.result);

        if (table && table.length > 1) {
          let title = JSON.parse(table[0].content);

          const temp = cloneDeep(table);
          this.gridData = temp.slice(1);
          const temp2 = toPairs(title);
          this.tableTitle = temp2.filter(o => o[0] !== "levelState");

          let totalTime = 0;
          let scoreList =
            this.gridData &&
            this.gridData.map(o => (totalTime = totalTime + o.passTime));
          this.totalTime = totalTime;
          this.refreshTable = false;
          this.$nextTick(() => {
            this.refreshTable = true;
          });
        }
      }
    },
    async loadAvgData() {
      let avgData = await this.$http.getPatientGameAvgStatistic(this.gameId, {
        age: this.patientAge
      });
      this.avgData = avgData;
    },
    close() {
      this.isDetails = false;
    },
    gameStart() {
      this.isDetails = true;
    },
    startReplay() {
      this.isDetails = false;
      this.$router.push({
        path: `${this.$route.path}/${this.item.playbackId}/${this.item.url}`
      });
    },
    tableValueFormatter(row, item) {
      const levelAvgData = this.avgData.filter(o => o.level === row.levelNum);

      const avgData =
        levelAvgData.length > 0 && levelAvgData[0].data
          ? levelAvgData[0].data
          : undefined;
      //   return row[item[0]];
      if (item[0] === "levelNum") {
        return `${row[item[0]]}`;
      } else if (avgData && avgData[item[1]]) {
        const avgValue = avgData[item[1]];
        if (avgValue.sumVal) {
          const calcAvg =
            avgValue.count > 0
              ? (avgValue.sumVal / avgValue.count).toFixed(2)
              : avgValue.sumVal;
          return `${row[item[0]]}（${calcAvg}）`;
        } else {
          return `${row[item[0]]}（--）`;
        }
      } else {
        return `${row[item[0]]}（--）`;
      }
    }
  }
};
</script>

<template>
  <div class="replayCardAnalysis">
    <div class="ReplayCell">
      <img class="replayMode" @click="gameStart" :src="item.icon" />
      <div class="replayImgMode" @click="gameStart"></div>
      <img class="replayIcon" @click="gameStart" src="../../assets/视频回放.svg" />
      <p class="cardText">{{item.stationName || '--'}}</p>
      <p class="cardText">{{item.patientName || '--'}} （{{age}}）</p>
      <p class="cardText">训练端：{{item.client || '--'}}</p>
      <p class="cardText">开始时间：{{startTime || '--'}}</p>
      <p class="cardText">游戏时长：{{trainingTime || '--'}}秒</p>
      <div v-if="item.trainingId" class="dialogView">
        <el-popover placement="top" trigger="click" popper-class="popperClass">
          <div class="popperTotalTIme">本次闯关总时长：{{totalTime || '--'}}（秒）</div>
          <el-table
            :data="gridData"
            height="300"
            v-if="gridData.length > 0 && refreshTable"
            class="popperClassTable"
          >
            <el-table-column
              v-for="item in tableTitle"
              :key="item[0]+ item[1]"
              min-width="60"
              :property="item[0]"
              :label="item[1]"
              :formatter="(row) => tableValueFormatter(row, item)"
            ></el-table-column>
            <el-table-column width="100" property="levelState" label="闯关结果">
              <template slot-scope="scope">
                <div v-if="scope.row.levelState === 'success'">
                  <span class="winSuccess">
                    成功
                    <i class="el-icon-success"></i>
                  </span>
                </div>
                <div v-else-if="scope.row.levelState === 'fail'">
                  <span class="winFailed">
                    失败
                    <i class="el-icon-error"></i>
                  </span>
                </div>
                <div v-else>
                  <span>未完成</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <span v-else class="noDataView">暂无数据</span>
          <el-button slot="reference" type="text" @click="onClick">...</el-button>
        </el-popover>
      </div>
      <span class="gameRateStar">
        评估值：
        <span v-if="item.quality && item.quality >= 25">{{item.quality}}</span>
        <span v-else-if="item.quality && item.quality >= 10" style="color: #FFB200">{{item.quality}}</span>
        <span v-else-if="item.quality && item.quality < 10" style="color: #FF0000">{{item.quality}}</span>
        <span
          style="color: #FF0000"
          v-else-if="item.state == 'REBUILD' && item.quality== 0"
        >{{item.quality}}</span>
        <span v-else>--</span>
      </span>
    </div>
    <Dialog title="回放" v-if="isDetails" @close="close" btn-text="开始回放" @confirm="startReplay"></Dialog>
  </div>
</template>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  border: 0;

  .popperClass {
    max-height: 50%;
    min-width: 40%;
    min-height: 200px;
    max-width: 80%;
    position: fixed;
    padding: 15px 30px;
    top: 50% !important;
    left: 50% !important;
    transform: translateX(-50%) translateY(-50%);

    .noDataView {
      text-align: center;
      display: inline-block;
      width: 100%;
      margin-top: 100px;
    }

    .popperClassTable {
      .cell {
        padding-right: 0px !important;
        padding-left: 0px !important;
      }
    }

    .popperTotalTIme {
    }

    .winSuccess {
      > i {
        color: #67c23a;
        padding-left: 5px;
      }
    }

    .winFailed {
      color: red;

      > i {
        padding-left: 5px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.replayCardAnalysis {
  width: 200px;
  height: 280px;
  margin: 10px;
  display: inline-block;

  .dialogView {
    float: right;
    margin-bottom: 5px;

    margin-right: 10px;
    margin-top: -15px;

    .el-button--text {
      font-size: 16px;
    }
  }

  .Dialog {
    position: relative;

    .pointBox {
      position: absolute;
      left: 30px;
    }
  }

  .ReplayCell {
    display: inline-block;
    position: relative;
    width: 200x;
    height: 280px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(233, 233, 233, 1);
    box-sizing: border-box;
    cursor: pointer;

    > p {
      margin-left: 17px;
      margin-right: 17px;
      overflow: hidden;
      //   text-overflow: ellipsis;
      //   white-space: nowrap;
    }

    img {
      width: 200px;
      height: 120px;
      margin-bottom: 5px;
    }

    .cardText {
      font-size: 14px;
      line-height: 16px;
      padding-left: 12px;
      color: rgba(0, 0, 0, 0.85);
      margin: 5px 0;
    }

    .gameRateStar {
      padding: 0 12px;
      display: inline-block;
    }

    .replayIcon {
      position: relative;
      float: left;
      width: 35px;
      height: 35px;
      margin-top: -85px;
      margin-left: 85px;
    }

    .replayImgMode {
      position: absolute;
      top: 0;
      left: 0px;
      width: 200px;
      height: 120px;
      opacity: 0.6;
      background-color: #000000 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gameReplayAnalysis/replayCard.vue